import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { CommonService } from '@app/services/common.service';
import { SpaceValidator } from '@app/validators/SpaceValidator';
import { ManagedCouponService } from '../managed-coupon.service';
import { Coupon, CouponType, CouponUsage } from '../managed-coupon.model';
@Component({
  selector: 'app-add-coupon',
  templateUrl: './add-coupon.component.html',
  styleUrls: ['./add-coupon.component.scss'],
})
export class AddCouponComponent implements OnInit {
  mode: string;
  formGroup: FormGroup;
  today = new Date();
  cupontype = CouponType;
  couponUsageEnum = CouponUsage;
  couponEnums: CouponType[] = Object.values(this.cupontype).filter(
    (value) => typeof value === 'number'
  ) as number[];

  // couponUsages: CouponUsage[] = Object.values(this.couponUsageEnum).filter(
  //   (value) => typeof value === 'number'
  // ) as number[];

  couponNameList: string[];
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AddCouponComponent>,
    private manageCouponService: ManagedCouponService,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) private editData: Coupon
  ) {}
  ngOnInit(): void {
    this.loadData();
    this.editData ? (this.mode = 'edit') : (this.mode = 'add');
    this.formGroup = this.fb.group({
      name: [
        '',
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      couponType: [
        '',
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      usage: [
        [1],
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      expiredAt: ['', [Validators.required]],
      value: [
        '',
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      maxDiscount: [
        '',
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      description: [
        '',
        [
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
        ],
      ],
      maxUser: [
        '',
        [
          Validators.required,
          SpaceValidator.cannotContainEndingSpace,
          SpaceValidator.cannotContainStartingSpace,
          Validators.min(1),
        ],
      ],
    });
    if (this.mode === 'edit') {
      this.setEditFormValue();
    }
  }
  setEditFormValue() {
    this.formGroup.patchValue({
      name: this.editData.name,
      maxDiscount: this.editData.maxDiscount,
      value: this.editData.value,
      couponType: this.editData.couponType,
      usage: this.editData.usage,
      maxUser: this.editData.maximumUsers,
      description: this.editData.description,
      expiredAt: this.editData.expiredAt,
    });
  }
  private loadData() {
    this.manageCouponService.getCouponList().subscribe((response) => {
      this.couponNameList = response.coupons.map((coupon: { name: string }) => {
        return coupon.name;
      });
    });
  }

  add() {
    const makePayload = {
      name: this.formGroup.get('name')?.value,
      maxDiscount: Number(this.formGroup.get('maxDiscount')?.value),
      expiryDate: this.formGroup.get('expiredAt')?.value,
      value: Number(this.formGroup.get('value')?.value),
      couponType: this.formGroup.get('couponType')?.value,
      usage: this.formGroup.get('usage')?.value,
      description: this.formGroup.get('description')?.value,
      maximumUsers: Number(this.formGroup.get('maxUser')?.value),
    };

    makePayload.expiryDate = new Date(
      makePayload.expiryDate
    ).toLocaleDateString('en', { timeZone: 'Asia/kolkata' });

    if (this.mode === 'add') {
      this.formGroup.markAllAsTouched();
      if (this.formGroup.invalid) {
        this.commonService.FailedAlertDialog({
          dialog: this.dialog,
          message: `Enter all the required fields.`,
        });
        return;
      }
      const isCouponExit = this.couponNameList.includes(
        this.formGroup.value.name
      );
      if (isCouponExit === true) {
        this.commonService.FailedAlertDialog({
          dialog: this.dialog,
          message: `Coupon already exist.`,
        });
      } else {
        this.manageCouponService.addCoupon(makePayload).subscribe({
          next: () => this.dialogRef.close(true),
          error: (err: { error: { code: string } }) => {
            this.commonService.FailedAlertDialog({
              dialog: this.dialog,
              message: `Errors.${err.error.code}`,
            });
          },
        });
      }
    }
    if (this.mode === 'edit' && this.editData.id) {
      const expiryDateControl = this.formGroup.get('expiredAt');

      if (expiryDateControl?.invalid) {
        expiryDateControl.markAsTouched();
        this.commonService.FailedAlertDialog({
          dialog: this.dialog,
          message: `Please enter a valid expiry date.`,
        });
        return;
      }

      if (this.formGroup.invalid) {
        this.formGroup.markAllAsTouched();

        this.commonService.FailedAlertDialog({
          dialog: this.dialog,
          message: `Enter all the required fields.`,
        });
        return;
      }
      const Payload = {
        name: String(this.formGroup.get('name')?.value),
        maxDiscount: Number(this.formGroup.get('maxDiscount')?.value),
        expiryDate: this.formGroup.get('expiredAt')?.value,
        value: Number(this.formGroup.get('value')?.value),
        couponType: this.formGroup.get('couponType')?.value,
        usage: this.formGroup.get('usage')?.value,
        description: this.formGroup.get('description')?.value,
        maximumUsers: Number(this.formGroup.get('maxUser')?.value),
      };

      Payload.expiryDate = new Date(Payload.expiryDate).toLocaleDateString(
        'en',
        { timeZone: 'Asia/kolkata' }
      );
      this.manageCouponService
        .updateCoupon(Payload, this.editData.id)
        .subscribe({
          next: () => this.dialogRef.close(true),
          error: (err: { error: { code: string } }) => {
            this.commonService.FailedAlertDialog({
              dialog: this.dialog,
              message: `Errors.${err.error.code}`,
            });
          },
        });
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}
